import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/CustomListActions";
import * as api from "../../api/CustomListApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* deleteTechnicianFromPlanned(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.removeTechnicianPlannedMaintenance(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteTechnicianFromUnplanned(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.removeTechnicianUnplannedMaintenance(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.DELETE_TECHNICIAN_FROM_PLANNED, deleteTechnicianFromPlanned);
    yield takeEvery(actions.Types.DELETE_TECHNICIAN_FROM_UNPLANNED, deleteTechnicianFromUnplanned);
}

const CustomListSaga = [fork(watchAll)];

export default CustomListSaga;
